// settings#api_keys — copy-to-clipboard for a freshly minted key, which is the
// only time we ever show it. Also runs after settings#create_api_key, which
// renders this template.
import { registerPage } from "../first"

const RESET_DELAY_MS = 1600

export const SettingsApiKeysPage = {
  onDomReady(): void {
    document.querySelectorAll<HTMLButtonElement>("[data-copy]").forEach((button) => {
      button.addEventListener("click", () => void copyToClipboard(button))
    })
  },
}

registerPage("SettingsApiKeysPage", SettingsApiKeysPage)

async function copyToClipboard(button: HTMLButtonElement): Promise<void> {
  const value = button.dataset.copy
  if (!value) return

  const original = button.textContent

  try {
    await navigator.clipboard.writeText(value)
  } catch {
    // No clipboard permission (or no clipboard at all) — tell them to do it
    // by hand rather than silently doing nothing.
    button.textContent = "Press ⌘C"
    return
  }

  button.textContent = "Copied"
  button.disabled = true

  window.setTimeout(() => {
    button.textContent = original
    button.disabled = false
  }, RESET_DELAY_MS)
}
